// import moment from "moment";

// const AttendanceGrid = ({ attendanceData, selectedMonth }) => {
//     // Step 1: Get all days in the selected month
//     const daysInMonth = moment(selectedMonth, "YYYY-MM").daysInMonth();
//     const dates = Array.from({ length: daysInMonth }, (_, i) => i + 1);

//     // Step 2: Extract all unique student names
//     const studentSet = new Set();
//     attendanceData.forEach((entry) => {
//         entry.present_names?.split(",").forEach((name) => name && studentSet.add(name.trim()));
//         entry.absent_names?.split(",").forEach((name) => name && studentSet.add(name.trim()));
//     });
//     const students = Array.from(studentSet);

//     // Step 3: Build attendance matrix
//     const matrix = students.map((student) => {
//         const row = { name: student };

//         for (let day = 1; day <= daysInMonth; day++) {
//             const entry = attendanceData.find((e) =>
//                 moment(e.date).date() === day &&
//                 (e.present_names?.includes(student) || e.absent_names?.includes(student))
//             );

//             if (!entry) {
//                 row[day] = "";
//             } else if (entry.present_names?.includes(student)) {
//                 row[day] = "P";
//             } else if (entry.absent_names?.includes(student)) {
//                 row[day] = "-";
//             } else {
//                 row[day] = "";
//             }
//         }

//         return row;
//     });

//     return (
//         <div className="overflow-auto border mt-4">
//             <table className="table-auto border-collapse min-w-full text-center w-100">
//                 <thead style={{background: "#e9e9e9"}}>
//                     <tr className="bg-gray-200">
//                         <th className="border px-2 py-1">Name</th>
//                         {dates.map((day) => (
//                             <th key={day} className="border px-2 py-1">{day}</th>
//                         ))}
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {matrix.map((row, idx) => (
//                         <tr key={idx}>
//                             <td className="border px-2 py-1 font-medium">{row.name}</td>
//                             {dates.map((day) => (
//                                 <td key={day} className="border px-2 py-1">{row[day]}</td>
//                             ))}
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         </div>
//     );
// };

// export default AttendanceGrid;





import moment from "moment";
import { useMemo } from "react";

const AttendanceGrid = ({ attendanceData, selectedMonth }) => {

    const daysInMonth = moment(selectedMonth, "YYYY-MM").daysInMonth();
    const dates = Array.from({ length: daysInMonth }, (_, i) => i + 1);

    // 🔹 Build lookup map ONCE
    const attendanceMap = useMemo(() => {
        const map = {};

        attendanceData.forEach((entry) => {
            const day = moment(entry.date).date();

            entry.present_names?.split(",").forEach(name => {
                if (!name) return;
                const key = `${name.trim()}_${day}`;
                map[key] = "P";
            });

            entry.absent_names?.split(",").forEach(name => {
                if (!name) return;
                const key = `${name.trim()}_${day}`;
                map[key] = "-";
            });
        });

        return map;
    }, [attendanceData]);

    // 🔹 Unique students
    const students = useMemo(() => {
        const set = new Set();
        attendanceData.forEach((entry) => {
            entry.present_names?.split(",").forEach(n => n && set.add(n.trim()));
            entry.absent_names?.split(",").forEach(n => n && set.add(n.trim()));
        });
        return [...set];
    }, [attendanceData]);

    const matrix = useMemo(() => {
        return students.map(student => {
            const row = { name: student };
            dates.forEach(day => {
                row[day] = attendanceMap[`${student}_${day}`] || "";
            });
            return row;
        });
    }, [students, attendanceMap, dates]);

    return (
        <div className="overflow-auto border mt-4">
            <table className="table-auto border-collapse min-w-full text-center w-100">
                <thead style={{ background: "#e9e9e9" }}>
                    <tr>
                        <th className="border px-2 py-2">Name</th>
                        {dates.map(day => <th className="border px-2 py-2" key={day}>{day}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {matrix.map((row, idx) => (
                        <tr key={idx}>
                            <td className="border px-2 py-1 font-medium"><b>{row.name}</b></td>
                            {dates.map(day => <td className="border px-2 py-1" key={day}>{row[day]}</td>)}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AttendanceGrid;
